var map = {
	"./en-GB": [
		7797,
		797
	],
	"./en-GB.ts": [
		7797,
		797
	],
	"./fa-IR": [
		4432,
		432
	],
	"./fa-IR.ts": [
		4432,
		432
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 3542;
module.exports = webpackAsyncContext;